import script from "./DeveloperStatisticalList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeveloperStatisticalList.vue?vue&type=script&setup=true&lang=js"

import "./DeveloperStatisticalList.vue?vue&type=style&index=0&id=83ad78aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83ad78aa"]])

export default __exports__